import type Application from '@ember/application';

import { isTesting, macroCondition } from '@embroider/macros';

import ReactHistory from '../locations/shared-history';

export function initialize(application: Application) {
  if (macroCondition(isTesting())) {
    application.register('location:shared-history', ReactHistory);
  }
}

export default {
  initialize,
};
